import React, { PureComponent } from 'react';

import { getHighlightIndex } from '~/helper/utils';

import HighLightArea from './HighLightArea';
import MedianMarker from '../MedianMarker';

import './barChart.styl';

// we need this because of a weird IE Edge 14 bug
function myScale(val, bandWidth, domain) {
  return ((+val - domain[0]) / (domain[1] - domain[0])) * bandWidth;
}

class BarChart extends PureComponent {
  static defaultProps = {
    tranlateX: 0
  }

  onMouseEnter = (evt, data) => {
    this.props.onIcomeLayerEnter(data);
  }

  onMouseMove = (evt) => {
    const pos = { left: evt.clientX, top: evt.clientY };
    this.props.onIcomeLayerMove(pos);
  }

  onMouseLeave = () => this.props.onIcomeLayerLeave();

  getIncomeLayer = () => {
    const incomeLayer = this.props.data.incomeLayer.map((layer) => {
      const minY = this.getAbsYPos(layer.min);
      const maxY = this.getAbsYPos(layer.max);
      const height = Math.abs(minY - maxY);

      return (
        <HighLightArea
          key={`${layer.key}__${this.props.type}`}
          height={height}
          width={this.props.width}
          y={maxY}
          active={this.props.activeIncomeLayer === layer.key}
          onMouseEnter={this.onMouseEnter}
          onMouseMove={this.onMouseMove}
          onMouseLeave={this.onMouseLeave}
          layer={layer.key}
        />
      );
    });

    return incomeLayer;
  }

  getAbsYPos(val) {
    // handle edges
    if (val > 6200) {
      return 0;
    }

    if (val < 200) {
      return this.props.scaleY('<200') + this.props.scaleY.bandwidth();
    }

    const barIndex = getHighlightIndex(val);
    const yKey = this.props.data.values[barIndex].key;
    // we extract the numbers of the key: '2001-2200' => [2001, 2200];
    const [yKeyStart, yKeyEnd] = yKey === '>6000' ? [6000, 6200] : yKey.split('-').map(d => +d);
    // y of the bar itself
    const y = this.props.scaleY(yKey);
    // scale inside the bar
    const offset = myScale(val, this.props.scaleY.bandwidth(), [yKeyStart, yKeyEnd]);

    return (y + this.props.scaleY.bandwidth()) - offset;
  }

  render() {
    return (
      <g>
        {this.getIncomeLayer()}
        <line
          className="yaxis__line"
          x1={this.props.type === 'left' ? this.props.width : 0}
          y1="0"
          x2={this.props.type === 'left' ? this.props.width : 0}
          y2={this.props.height - 15}
        />
        <MedianMarker
          key={`${this.props.type}-MedianMarker`}
          x="0"
          y={this.getAbsYPos(this.props.data.median)}
          dx={this.props.type === 'left' ? 0 : this.props.width}
          textAnchor={this.props.type === 'left' ? 'start' : 'end'}
          width={this.props.width}
          keyLabel={this.props.translate('chart.median')}
          label={this.props.data.median}
          currentLanguage={this.props.currentLanguage}
        />
      </g>
    );
  }
}

export default BarChart;



// WEBPACK FOOTER //
// ./src/components/BarChart/index.js